<div [formGroup]='parent' autocomplete="off" role="search" aria-describedby="search">
    <!-- <input type="text"
  (keyup)="searchTerm$.next($event.target.value)"> -->
    <label for="addressSearch" id="search" class="form-label">
        {{'Pension provider'}}
    </label>
    <input [formControlName]="controlName" class="form-control" style="margin-bottom: 10px;" id="addressSearch" name="addressSearch" [placeholder]="contentData['pensionProviderSearchplaceholder']"
        type="text" (keyup)="searchTerm$.next($event.target.value)" 
        [value]="parent.get([controlName]).value"
        [(ngModel)]="controllerData.value"
        [required]="controllerData['required']" autocomplete="off" [maxlength]="controllerData['maxlength']"> 

    <ul class="autofill" *ngIf="suggestiontext" [ngClass]="{'hideList':!isListAddressEnabled}">


        <li [(value)]="suggestiontext[i]" *ngFor="let txt of suggestiontext; let i = index" (click)="onSelectProvider(txt)">
            {{txt}}
          </li>
          
    </ul>
    <div class="form-validation-error clear-both" *ngIf=" parent && parent.get('addressline1') && parent.get('addressline1').touched && parent.get('addressline1').errors">
        <i class="icon icon-error" aria-hidden="true"></i>
        <p [id]="'address-error'">
            please enter an address
        </p>
    </div>

</div>
<div [id]="controlName+'-error'" class="form-validation-error error-wid" 
[ngClass]="{'width-100':(pageName === 'yourPensionSavings')}"
*ngIf="parent.get([controlName]).touched && parent.get([controlName]).errors
   && controllerData['errorMessage'] 
   && controllerData['errorMessage'] !== ''">
  <i class="icon icon-error" aria-hidden="true"></i>
  <!-- <p [id]="controlName+'-error-msg'" role="alert" 
  aria-live="polite" aria-hidden="false">{{controllerData['errorMessage']}}</p> -->
  <p *ngIf="parent.get(controlName).touched
    &&
    parent.get(controlName).hasError('required')" 
[id]="controlName +'-error'">{{controllerData['errorMessage']}}</p>

 <!-- <p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).errors.pattern" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMessageInvalid']}}
</p> 
<p *ngIf="parent.get(controlName).touched
       &&
    parent.get(controlName).hasError('matchInvalid')" [id]="controlName +'-invalid-error'">
    {{controllerData['errorMatch']}}
</p>  -->
<p *ngIf="parent.get(controlName).touched
       &&
       parent.get(controlName).hasError('notValidPensionProvider')" [id]="controlName +'-invalidPensionProvider-error'">
    {{controllerData['invalidErrorMessage']}}
</p>
</div>